/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import CustomInput from 'src/components/InputsComponent/CustomInput';

const GoogleAddressInput = ({
  value,
  onChange,
  label = 'Mailing Address',
  icon,
  id = 'address',
  name = 'address',
  placeholder = 'Enter Mailing Address',
  skipCurrentAddress = false, // ✅ NEW prop
  ...rest
}) => {
  const inputRef = useRef(null);
  const location = useLocation();

  // 🔹 Load Google Maps Places script dynamically if not loaded
  const loadGoogleMaps = (callback) => {
    if (window.google && window.google.maps && window.google.maps.places) {
      callback();
      return;
    }

    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.addEventListener('load', callback);
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyBhQRNW7-WSmz25E7KAlR1ASSAf_iHpmmw&libraries=places';
    script.async = true;
    script.defer = true;
    script.onload = callback;
    document.body.appendChild(script);
  };

  // ✅ Initialize Google Places Autocomplete
  useEffect(() => {
    // if (value) return;
    loadGoogleMaps(() => {
      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ['geocode'], // Get address results
        componentRestrictions: { country: ['us', 'ca'] }, // Allow all countries
      });

      // Handle when a place is selected from the dropdown
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place || !place.formatted_address) return;

        let postalCode = '';
        let city = '';
        let state = '';
        let country = '';
        let latitude = '';
        let longitude = '';
        let street = '';

        // Extract address components
        if (place.address_components) {
          place.address_components.forEach((comp) => {
            if (comp.types.includes('postal_code')) postalCode = comp.long_name;
            if (comp.types.includes('locality')) city = comp.long_name;
            if (comp.types.includes('administrative_area_level_1')) state = comp.long_name;
            if (comp.types.includes('country')) country = comp.long_name;
            if (comp.types.includes('route')) street = comp.long_name;
          });
        }

        // Extract coordinates
        if (place.geometry && place.geometry.location) {
          latitude = place.geometry.location.lat();
          longitude = place.geometry.location.lng();
        }

        // 🔹 Update address value in parent form
        onChange({ target: { name, value: place.formatted_address } });
      });
    });
  }, []);

  // ✅ On load — get current user’s address (street-level) using Geolocation + Google Reverse Geocoding
  useEffect(() => {
    if (!skipCurrentAddress && (!value || value.trim() === '')) {
      fetchCurrentAddress();
    }
  }, []);

  async function fetchCurrentAddress() {
    if (!navigator.geolocation || value) return;

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBhQRNW7-WSmz25E7KAlR1ASSAf_iHpmmw`,
          );
          const data = await response.json();
          if (data.results && data.results.length > 0) {
            const currentAddress = data.results[0].formatted_address;
            onChange({ target: { name, value: currentAddress } });
          }
        } catch (err) {
          console.error('Error getting current location:', err);
        }
      },
      (error) => {
        console.warn('⚠️ Geolocation denied or unavailable:', error.message);
      },
    );
  }
  return (
    <CustomInput
      inputRef={inputRef}
      label={label}
      icon={icon}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      autoComplete="off"
      {...rest}
    />
  );
};

export default GoogleAddressInput;
